import React from 'react'
import styled, { css } from 'styled-components'
import media from 'css-in-js-media'
import Img from 'gatsby-image'

import SwiperCore, { Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

// install Swiper components
SwiperCore.use([Autoplay])

// Import Swiper styles
import 'swiper/swiper.scss'

import { Variables } from '../styles/Variables'
import { H5 } from './Typography'

const Wrapper = styled.div`
    .swiper-container {
        padding: 0 30px;
        box-sizing: border-box;
        ${media('>=desktop')} {
            padding: 0 80px;
        }
    }

    ${media('<desktop')} {
        margin-bottom: -40px;
    }
`

const SlideContent = styled.div`
    position: absolute;
    top: 27px;
    left: 0;
    right: 0;
    z-index: 10;
    text-align: center;
    opacity: 0;
    transition: 2s opacity ease-out;
`

const Slider = styled(Swiper)`
    padding: 0;
    height: 100%;
    width: 100%;
    background: none;

    .swiper-wrapper {
        transition-timing-function: cubic-bezier(0.29, 0.46, 0.1, 1);
    }

    ${H5} {
        font-family: ${Variables.font.body};
        font-size: 14px;
        line-height: 120%;
        letter-spacing: 0.0025em;
        text-transform: none;
    }

    .swiper-slide-active ${SlideContent} {
        opacity: 1;
    }
`

const SlideshowSlideWrapper = styled.div`

`

const ImageWrap = styled.div`
    .gatsby-image-wrapper {
        max-height: 100%;
    }

    img {
        object-fit: contain !important;
        vertical-align: top;
        transform: translateZ(1px);
    }
`

const SlideshowScroll = ({ data }) => {

    return (
        <>
            {data && (
                <Wrapper>
                    <Slider
                        speed={1500}
                        slidesPerView="1"
                        loop={true}
                        spaceBetween={16}
                        autoplay={{ delay: 3000, disableOnInteraction: true }}
                        loopAdditionalSlides={1}
                        breakpoints={{
                            768: {
                                slidesPerView: 3,
                            },
                        }}
                    >
                        {data.slideshowImages &&
                            data.slideshowImages.map((slide, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <SlideshowSlideWrapper>
                                            <ImageWrap className="SlideshowImageWrap">
                                                <Img fluid={slide.fluid} alt="" />
                                            </ImageWrap>
                                        </SlideshowSlideWrapper>
                                    </SwiperSlide>
                                )
                            })}
                    </Slider>
                </Wrapper>
            )}
        </>
    )
}

export default SlideshowScroll
